import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent } from '@mui/material';
import Button from '@mui/material/Button';
import { useLangFile } from 'js/context/LanguageContext';

const LoginErrorDialog = ({ open, onClose }) => {
  const LangFile = useLangFile();

  return (
    <Dialog title={LangFile.LoginErrorDialog.title} onClose={onClose} open={open}>
      <DialogContent>
        <h4>{LangFile.LoginErrorDialog.description}</h4>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{LangFile.LoginErrorDialog.retry}</Button>
      </DialogActions>
    </Dialog>
  );
};

LoginErrorDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default memo(LoginErrorDialog);
